<template>
  <div class="left-wrapper">
    <div class="divList">
      <div class="sendItems" v-for="(item,key) in sendItems" @click="clickItem(key)" :key="key">
        <!-- 公告列表 -->
        <div class="sendDivList">
          <!--:style="{backgroundImage:'url('+item.imgPath+')'}"-->
          <div
            v-if="key === 0"
            class="sendFirst"
            :style="{backgroundImage:'url('+item.coverPicUrl+')'}"
          >
            <div class="firstTitle">{{item.title}}</div>
          </div>
          <div v-else class="sendOther">
            <div class="otherTitle">{{item.title}}</div>
            <!--:style="{backgroundImage:'url('+item.imgPath+')'}"-->
            <!--<img v-if="item.coverPicUrl" class="sendOtherPic" :src="item.coverPicUrl"/>-->
            <div
              v-if="item.coverPicUrl"
              class="sendOtherPic"
              :style="{backgroundImage:'url('+item.coverPicUrl+')'}"
            ></div>
            <div v-else class="zhanwei">请选择封面图</div>
          </div>
        </div>
        <!-- 悬浮处理函数 -->
        <div class="sendListHandler">
          <div class="box" style="justify-content: space-between">
            <div class="box">
              <div
                class="send-handler iconfont icon-jiantouxiangshang"
                style="padding-right:30px"
                @click.stop="moveForward(key)"
              ></div>
              <div class="send-handler iconfont icon-jiantouxiangxia" @click.stop="moveBack(key)"></div>
            </div>
            <div class="send-handler iconfont icon-shanchu1" @click.stop="delArticle(key)"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加按钮 -->
    <div class="send-add" @click="addSend">
      <div class="addicon iconfont icon-tianjia"></div>
    </div>
  </div>
</template>

<script>
var that;
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    sendItems: Array
  },
  methods: {
    moveForward(index) {
      this.$emit("moveForward", index);
    },
    moveBack(index) {
      this.$emit("moveBack", index);
    },
    delArticle(index) {
      this.$emit("delArticle", index);
    },
    addSend() {
      that.$emit("addSend");
    },
    clickItem(index) {
      that.$emit("changeInfo", index);
    }
  },
  mounted() {
    that = this;
  }
};
</script>

<style scoped>

.left-wrapper{
    /*background: #fff;*/
    border-radius: 5px;
}
.divList {
    height: 680px;
    width: 470px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
    overflow-y: auto;
}
.divList::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.divList::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.divList::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.3);
}
.sendItems {
  position: relative;
}
.sendDivList {
  padding: 15px;
  border-bottom: 1px solid #d7dde4;
}
.sendItems:first-child .sendDivList {
  padding: 0;
}
.sendFirst {
  width: 100%;
  height: 200px;
  /*background-size: cover;*/
  background-repeat: no-repeat;
  background-position: center;
  background-size: 470px 200px;
  position: relative;
}
.firstTitle {
  position: absolute;
  width: 100%;
  height: 34px;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  color: #fff;
  font-size: 12px;
  line-height: 34px;
  padding-left: 10px;
}
.sendOther {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.sendOtherPic {
  width: 80px;
  height: 80px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.zhanwei {
  width: 80px;
  height: 80px;
  text-align: center;
  color: #999;
  background: #f1f1f1;
  padding: 20px 10px 10px 10px;
}
.otherTitle {
  padding-right: 20px;
  flex: 1;
}
.sendItems:hover .sendListHandler {
  display: block;
}
.sendListHandler {
  position: absolute;
  width: 100%;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: none;
  padding: 0 10px;
}
.send-handler {
  color: #fff;
  font-size: 22px;
  line-height: 50px;
}
.send-add {
  height: 100px;
  text-align: center;
  cursor: pointer;
  background:#f4f4f4;
  border:1px solid #ddd

}
.addicon {
  color: #bbbbbb;
  font-size: 36px;
  line-height: 100px;
}
</style>
